export const BOX_CLASSNAME = "flex items-center border border-grey-usp px-2 py-1.25 text-sm tracking-wide text-grey-dark";
